"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arc = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var arc = function (r, value) {
    value /= 100;
    var angle = 2 * Math.PI * (value - 1 / 4);
    var x = r * Math.cos(angle);
    var y = r * Math.sin(angle);
    var sweep = Math.round(value);
    return "M .01 " + -r + " A " + r + " " + r + " 0 " + sweep + " 1 " + x + " " + y;
};
exports.Arc = function (props) {
    var value = props.value, strokeWidth = props.strokeWidth, size = props.size, className = props.className;
    var viewBox = -size / 2 + " " + -size / 2 + " " + size + " " + size;
    var d = arc((size - strokeWidth) / 2, value);
    return (React.createElement("svg", { className: className, width: size, height: size, viewBox: viewBox },
        React.createElement("path", { d: d, strokeWidth: value !== 0 ? strokeWidth : 0 })));
};
exports.Arc.displayName = 'Arc';
//# sourceMappingURL=Arc.js.map